import React from "react";
import { ImportHelperDetails } from "../component/import-details";
export const ImportDetailsHelper: React.FC = () => <ImportHelperDetails />;
